import React, { useEffect, useState } from 'react'
import SidePanelTaskCreator from '../../Common/SidePanelTaskCreator'
import TitleBar from '../../Common/TitleBar'
import DashboardHeader from '../../Common/DashboardHeader'
import { ScrollPanel } from 'primereact/scrollpanel'
import DashboardFooter from '../../Common/DashboardFooter'
import RowBuy from './RowBuy'
import { FaSpinner } from 'react-icons/fa6'
import { useDispatch } from 'react-redux'
import { fetchPackageList } from '../../../Redux/Actions/CreatorBuyPackageAction'
import Pagination from '../../Common/Pagination'
const BuyPackage = () => {
    const [isActive, setIsActive] = useState(true);
    const toggleClass = () => {
        setIsActive(!isActive);
    };
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalItemOnPage: 20
    });
    const dispatch = useDispatch()
    const [data, setData] = useState([])
    const [loader, setLoader] = useState({
        fetch: true
    })  
    const fetchData = () => {
        dispatch(fetchPackageList("fetch-package-list", setData, setLoader, loader))
    }
    useEffect(() => {
        fetchData()
    }, [])
    const indexOfLastTodo = pagination.currentPage * pagination.totalItemOnPage;
    const indexOfFirstTodo = indexOfLastTodo - pagination.totalItemOnPage;
    const currentTodo = data.slice(indexOfFirstTodo, indexOfLastTodo)
    return (

        <>
            <TitleBar title="Buy Package" />
            <div className="dashboard earnings_payouts container-fluid overflow-hidden">
                <div className="row">

                    <div className={`col-lg-2 col-md-3 col-sm-4 col-12 side-nav ${isActive ? "nav-show" : "nav-hide"}`}>
                        <SidePanelTaskCreator />
                    </div>
                    <div className={` p-0 ${isActive ? "col-lg-10 col-md-9 col-sm-8 col-12" : "col-12"} main-content`}>
                        <div>
                            <div className="row">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 ps-0 pe-0">
                                    <div className="dashboard-in main_task_wrapper">

                                        <DashboardHeader toggleSidebar={toggleClass} title="Buy Package" />


                                        <div className="custombar2 content-area pt-0" style={{ height: "100vh" }}>
                                            {
                                                loader.fetch ? <div className='d-flex align-items-center justify-content-center' style={{ height: "100vh" }}> <FaSpinner className='spin ms-1 w-100 d-flex mt-4' style={{ fontSize: "30px" }} /></div> :

                                                    <div className="content-area-in tab-style">
                                                        <div className='creator_new_task h-100 mt-4 mt-lg-0'>
                                                            <div className='account-block'>
                                                                <div className='row'>
                                                                    {currentTodo.length > 0 ? currentTodo.map((curElem, i) => {
                                                                        return (
                                                                            <React.Fragment key={i}>
                                                                                <RowBuy curElem={curElem} />
                                                                            </React.Fragment>

                                                                        )
                                                                    }) : <div className='d-flex justify-content-center aligm-items-center'>No package available</div>}
                                                                </div>
                                                                <div className='mt-2'>
                                                                    <Pagination
                                                                        listData={data}
                                                                        pagination={pagination}
                                                                        setPagination={setPagination}
                                                                        currentTodo={currentTodo}
                                                                        listArr={data}
                                                                        loader={loader.fetch}
                                                                    />
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>}
                                        </div>
                                        <div className="d-none d-lg-block">
                                            <DashboardFooter />
                                        </div>

                                    </div>
                                </div>
                                <div className="d-block d-lg-none">
                                    <DashboardFooter />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}

export default BuyPackage
